export default __webpack_public_path__ + "static/media/Tonmoy-Talukder.87dd3f9b.png";